"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWindowDimensions = void 0;

var getWindowDimensions = function getWindowDimensions() {
  return window.innerHeight && window.innerWidth ? {
    px_width: Math.round(window.innerWidth),
    px_height: Math.round(window.innerHeight)
  } : undefined;
};

exports.getWindowDimensions = getWindowDimensions;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/rio-sdk-web/dist/cjs/utils/windowDimensions.js
// module id = 3466
// module chunks = 11